import { type AppDispatch, type RootState } from '../store'
import { ACCESS_KEY, USER_ID_KEY, urlAPI } from '../../urls'

import { type ApiResponse } from '../../types/userTypes/TAuth'
import getChatListAdapter, { singleChatAdapterForList, sortChatsForChatList } from '../../functions/adapters/chatList/getChatListAdapter'
import { setChatList } from '../slices/chatListSlice'
import { getQueryChats } from '../../functions/shared/api/queries/getQueryChats'
import { createLoaderThunk } from '../../functions/shared/api/thunkFactory'
import { endpoints } from '../../functions/shared/api/apiConfig'
import { apiFetch } from '../../functions/shared/api/client'
import QueryString from 'qs'
import { takeDataArray } from '../../functions/shared/api/adapters'
import { setChatIsLoading, setChatRooms } from '../slices/chatSlice'
import { removeDataAttributes } from '../../functions/adapters/universal/removeDataAttributes'

export const getChatList = () => async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
        const jwt = window.localStorage.getItem(ACCESS_KEY) ?? ''
        const userID = window.localStorage.getItem(USER_ID_KEY) ?? ''

        const bodyObject = {
            method: 'GET',
            collection: 'users',
            id: +userID,
            //  query: getQueryChats()
            query: 'populate[Chats][populate][Users][populate][0]=ContactInfo,Type,DeviceToken' +
                 '&populate[Chats][populate]=LastMessage'
        }

        const response = await fetch(`${urlAPI}`, {
            method: 'POST',
            body: JSON.stringify(bodyObject),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwt}`
            }
        })
        const responseJSON = await response.json() as unknown as ApiResponse
        if (responseJSON.success) {
            if (responseJSON.response.error != null) {
                // error handling
                return {
                    ...responseJSON,
                    isSuccessful: false
                }
            } else {
                dispatch(
                    setChatList(
                        getChatListAdapter(responseJSON, +userID)
                    )
                )
            }
        }
        return {
            ...responseJSON,
            isSuccessful: true
        }
    } catch (error) {
        console.log(error)
        return {
            isSuccessful: false
        }
    }
}




export const fetchChatRooms = createLoaderThunk(
    'fetchChatRooms',
    {
        start:  () => setChatIsLoading(true),
       // success: (arr: any[]) => setChatRooms(arr),
       success: (arr: any[]) => {
        console.log(arr,"arr")
    const userId = Number(window.localStorage.getItem(USER_ID_KEY))

    const adapted = arr
        .map(raw =>
            singleChatAdapterForList(userId)(
                removeDataAttributes(raw)
            )
        )
        .filter(Boolean)

    return setChatList(sortChatsForChatList(adapted))
},
        error:  (_: string) => setChatIsLoading(false),
    },
    async () =>
        await apiFetch<any[]>({
            v2:     { path: endpoints.adminRequests.chats , params: { noLimit: true } },
            legacy: {
                collection: 'chat-rooms',
                // query: QueryString.stringify(
                //     { populate: chatPopulate, filters: { Users: { id: { $eq: window.localStorage.getItem(USER_ID_KEY) } } } },
                //     { encodeValuesOnly: true }
                // ),
                
            },
            adapter: (raw) => {
                const arr = takeDataArray(raw);
                return arr;
            },
        })
);